import globalEventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'
import isMobile from 'toxilibs/extlibs/is_mobile.min.js'

globalEventBus.on('challenge selected', function (index) {
    if (index === 'first_steps') {
        if (isMobile.any) {
            $('#text_tutorial .keyboard-keys').hide()
            $('#text_tutorial .swipe').show()
        } else {
            $('#text_tutorial .keyboard-keys').show()
            $('#text_tutorial .swipe').hide()
        }

        $('#text_tutorial').show()
    } else {
        $('#text_tutorial').hide()
    }
})
